import { IUser } from '@/app/state/app/collections/dataTypes';
import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import React from 'react';
import { ListItem } from './ListItem';

type Props = {
    user: IUser;
};

export const GeneralInfoSection = ({ user }: Props) => {
    const userInfo = [
        {
            label: TranslationHelper.translate('Login'),
            value: user.login,
        },
        {
            label: TranslationHelper.translate('First name'),
            value: user.name,
        },
        {
            label: TranslationHelper.translate('Surname'),
            value: user.surname,
        },
    ];

    return (
        <>
            {userInfo.map(({ label, value }) => (
                <ListItem label={label} value={value} key={label} />
            ))}
        </>
    );
};
